var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteAddToCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.94 9.00001C10.72 9.00001 8.92 7.21001 8.92 4.99001C8.92 4.28001 9.11 3.58001 9.46 2.97001H3.71L3.68 2.73001C3.56 1.72001 2.7 0.950012 1.68 0.950012H1.54C1.17 0.950012 0.870003 1.25001 0.870003 1.62001C0.870003 1.99001 1.17 2.29001 1.54 2.29001H1.69C2.03 2.29001 2.32 2.54001 2.36 2.88001L3.28 10.73C3.48 12.42 4.91 13.69 6.61 13.69H13.61C13.98 13.69 14.28 13.39 14.28 13.02C14.28 12.65 13.98 12.35 13.61 12.35H6.61C5.76 12.35 5 11.81 4.72 11.01H12.71C14.33 11.01 15.72 9.85001 16.01 8.25001L16.17 7.37001C15.41 8.39001 14.21 9.00001 12.94 9.00001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.56 17.05C6.30006 17.05 6.9 16.4501 6.9 15.71C6.9 14.9699 6.30006 14.37 5.56 14.37C4.81994 14.37 4.22 14.9699 4.22 15.71C4.22 16.4501 4.81994 17.05 5.56 17.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.27 17.05C13.0101 17.05 13.61 16.4501 13.61 15.71C13.61 14.9699 13.0101 14.37 12.27 14.37C11.5299 14.37 10.93 14.9699 10.93 15.71C10.93 16.4501 11.5299 17.05 12.27 17.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.93 5.65004H12.27V6.99004C12.27 7.36004 12.57 7.66004 12.94 7.66004C13.31 7.66004 13.61 7.36004 13.61 6.99004V5.65004H14.95C15.32 5.65004 15.62 5.35004 15.62 4.98004C15.62 4.61004 15.32 4.31004 14.95 4.31004H13.61V2.96004C13.61 2.59004 13.31 2.29004 12.94 2.29004C12.57 2.29004 12.27 2.59004 12.27 2.96004V4.30004H10.93C10.56 4.30004 10.26 4.60004 10.26 4.97004C10.26 5.35004 10.56 5.65004 10.93 5.65004Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteAddToCart);
export default __webpack_public_path__ + "static/media/white-add-to-cart.320dbb23cc4954196168875d5679243b.svg";
export { ForwardRef as ReactComponent };